module.exports = __webpack_public_path__ + "img/HTCC-AB01.d175cc60.jpg";